import { SelectOptions } from '@cbuild/controls';

export const budgets = [
  '5L to 10L',
  '10L to 15L',
  '15L to 20L',
  '20L to 25L',
  '25L to 30L',
  '30L to 40L',
  '40L to 50L',
  '50L to 60L',
  '60L to 70L',
  '70L to 80L',
  '80L to 90L',
  '90L to 1Cr',
  '1Cr to 1.2Cr',
  '1.2Cr to 1.4Cr',
  '1.4Cr to 1.6Cr',
  '1.6Cr to 1.8Cr',
  '1.8Cr to 2Cr',
  '2Cr to 2.2cr',
  '2.2cr to 2.4Cr',
  '2.4Cr to 2.6Cr',
  '2.6Cr to 2.8Cr',
  '2.8Cr to 3Cr',
  '3Cr to 3.2Cr',
  '3.2Cr to 3.4Cr',
  '3.4Cr to 3.6Cr',
  '3.6Cr to 3.8Cr',
  '3.8Cr to 4Cr',
  '4Cr to 4.2CR',
  '4.2Cr to 4.4Cr',
  '4.4Cr to 4.6Cr',
  '4.6Cr to 4.8Cr',
  '4.8Cr to 5Cr',
  '5Cr to 5.5Cr',
  '5.5Cr to 6Cr',
  '6Cr to 6.5Cr',
  '6.5Cr to 7cr',
  '7Cr to 7.5Cr',
  '7.5Cr to 8Cr',
  '8Cr to 8.5Cr',
  '8.5Cr to 9Cr',
  '9Cr to 9.5Cr',
  '9.5Cr to 10Cr',
  '10Cr to 11Cr',
  '11Cr to 12Cr',
  '12Cr to 13Cr',
  '13Cr to 14Cr',
  '14Cr to 15Cr',
  '15Cr to 16Cr',
  '16Cr to 17Cr',
  '17Cr to 18Cr',
  '18Cr to 19Cr',
  '19Cr to 20Cr',
  '20Cr to 21Cr',
  '21Cr to 22Cr',
  '22Cr to 23Cr',
  '23Cr to 24Cr',
  '24Cr to 25Cr'
];
export const budgetOptions: SelectOptions = budgets.map(x => ({
  value: x,
  label: x
}));
